import { MutableRefObject, useEffect } from 'react';

export const useInnovationVideoPlay = (videoRef: MutableRefObject<any>) => {
  const video = videoRef?.current;

  const playFullScreen = () => {
    if (!video) {
      return;
    }

    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen();
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen();
    } else if (video.webkitEnterFullscreen) {
      // Для iOS
      video.webkitEnterFullscreen();
    }
  };

  useEffect(() => {
    const onChangeFullScreenMode = (e: Event) => {
      if (!video || e.target !== video) {
        return;
      }

      const isFullScreenMode =
        // @ts-ignore
        document.fullscreenElement ||
        // @ts-ignore
        document.webkitFullscreenElement ||
        // @ts-ignore
        document.mozFullScreenElement ||
        // @ts-ignore
        document.msFullscreenElement;

      if (isFullScreenMode) {
        video.controls = true;
        video.play();
      } else {
        video.controls = false;
        video.pause();
      }
    };

    document.addEventListener('fullscreenchange', onChangeFullScreenMode);
    document.addEventListener('webkitfullscreenchange', onChangeFullScreenMode);
    document.addEventListener('mozfullscreenchange', onChangeFullScreenMode);
    document.addEventListener('MSFullscreenChange', onChangeFullScreenMode);

    return () => {
      document.removeEventListener('fullscreenchange', onChangeFullScreenMode);
      document.removeEventListener(
        'webkitfullscreenchange',
        onChangeFullScreenMode,
      );
      document.removeEventListener(
        'mozfullscreenchange',
        onChangeFullScreenMode,
      );
      document.removeEventListener(
        'MSFullscreenChange',
        onChangeFullScreenMode,
      );
    };
  }, [video]);

  return { playFullScreen };
};
